import React from 'react'
import { CalenderIcon, defaultUserImg } from '../../../helper/imagepath'
import { appendImageURL, convertTimestampToDateWithTimezone, convertTimestampToTimeWithTimezone, formatAmount, getBookingDayjs, getBookingStatusClass } from '../../../helper/function'
import ShawerIcon from '../../../assets/img/svg/shawer-icon.svg'
import BadIcon from '../../../assets/img/svg/bad-icon.svg'
import Pagination from '../../../component/common/pagination'

const CleanningTabView = ({ data, pagination, onHandleDetails, loading, isDayOff, cleanerTimezone }) => {
  const { handlePageChange, currentPage, itemsPerPage, totalRecords } = pagination

  return (
    <>
      {isDayOff ? (
        <div className="row">
          {data?.CleanerUnavailability?.length > 0
            ? data?.CleanerUnavailability?.map((item, index) => {
                return (
                  <div className="col-md-12 col-lg-6 col-xl-4" key={index}>
                    <div className="common_card_div upcoming_cleanings_space_div">
                      <div className={`event_date_main_div mb-3`}>
                        <div className={`event_date_box`}>
                          <div className={`left_side`}>
                            {/* <i className="fa-solid fa-calendar" style={{ fontSize: '18px' }}></i> */}
                            <img className="img-fluids" src={CalenderIcon} alt="Icon" />
                          </div>
                          <div className={``}>
                            <p className={`place_text`}>Start Date</p>
                            <p className={`date_text`}>
                              <span>{item?.start_date_time ? convertTimestampToDateWithTimezone(item?.start_date_time, cleanerTimezone) : '-'}</span> |{' '}
                              <span>{item?.start_date_time ? convertTimestampToTimeWithTimezone(item?.start_date_time, cleanerTimezone) : '-'}</span>{' '}
                            </p>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className={`event_date_main_div`}>
                        <div className={`event_date_box`}>
                          <div className={`left_side`}>
                            <img className="img-fluids" src={CalenderIcon} alt="Icon" />
                          </div>
                          <div className={``}>
                            <p className={`place_text`}>End Date</p>
                            <p className={`date_text`}>
                              <span>{item?.end_date_time ? convertTimestampToDateWithTimezone(item?.end_date_time, cleanerTimezone) : '-'}</span> |{' '}
                              <span>{item?.end_date_time ? convertTimestampToTimeWithTimezone(item?.end_date_time, cleanerTimezone) : '-'}</span>{' '}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            : !loading && <h4 className="not_found text-center">No Data Found</h4>}
        </div>
      ) : (
        <div className="row">
          {data?.propertyScheduleData?.length > 0
            ? data?.propertyScheduleData?.map((item, index) => {
                const property = item?.properties
                const clients = item?.properties?.client
                return (
                  <div className="col-md-12 col-lg-6 col-xl-6" key={index}>
                    <div className="common_card_div upcoming_cleanings_space_div">
                      <div className="upcoming_cleanings_box_div">
                        <div className="upcoming_cleanings_inner_box upcoming_cleanings_flex_div mb-2">
                          <div className="user_img_div">
                            <div className="cleanings_img_div">
                              <img
                                className="img-fluid"
                                src={clients?.profile_image ? appendImageURL(clients?.profile_image) : defaultUserImg}
                                alt="Image"
                              />
                            </div>
                            <div className="user_right_contains">
                              <h6 className="mb-0">
                                {clients?.first_name} {clients?.last_name}
                              </h6>
                            </div>
                          </div>
                          <div className="show_box show_bg" onClick={() => onHandleDetails(item)}>
                            <p>Details</p>
                          </div>
                        </div>
                        <div className="user_right_contains">
                          <h6 className="mb-2">{`${item?.properties?.property_name}`}</h6>
                        </div>
                        <div className="upcoming_cleanings_flex_div mb-2">
                          <p className="fs-14 gray_color fw-400">{property?.address}</p>
                          <div className={`show_box ${getBookingStatusClass(item?.booking_status)}`}>
                            <p>{item?.booking_status}</p>
                          </div>
                        </div>
                        <div className="upcoming_cleanings_flex_div mb-2">
                          <div className="amount_div">
                            <p className="fs-14 black_color fw-400 me-3">{formatAmount(item?.properties?.total_value) || 0}</p>

                            <label className="cleanings_icon_box_div">
                              <img className="img-fluid" src={ShawerIcon} alt="Image" />
                              {property?.number_of_bathroom}
                            </label>
                            <label className="cleanings_icon_box_div">
                              <img className="img-fluid" src={BadIcon} alt="Image" />
                              {property?.number_of_rooms}
                            </label>
                          </div>
                        </div>
                        <div className="upcoming_cleanings_flex_div">
                          <p className="fs-14 dark_blue_color fw-400">
                            <span> {item?.booking_date_time ? getBookingDayjs(item, item?.properties?.timezone)?.format('DD MMM YYYY') : '-'}</span> |{' '}
                            <span>{item?.booking_date_time ? getBookingDayjs(item, item?.properties?.timezone)?.format('hh:mm A') : '-'}</span>
                          </p>
                          <div className="">
                            <p className="fs-16 black_color fw-500">{item?.schedule_number && `#${item?.schedule_number}`}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            : !loading && <h4 className="not_found text-center">No Data Found</h4>}
        </div>
      )}

      {(data?.propertyScheduleData?.length > 0 || data?.CleanerUnavailability?.length > 0) && (
        <Pagination currentPage={currentPage} onPageChange={handlePageChange} totalPages={totalRecords} itemsPerPage={itemsPerPage} />
      )}
    </>
  )
}
export default CleanningTabView
